import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import Layout from './app/layout';
import Home from './app/routes/Home';
import ServiceProvider from './app/routes/ServiceProvider';
import CustomerAgreement from './app/routes/customer-agreement';
import TermsAndPrivacy from './app/routes/terms-and-privacy';
import VendorAgreement from './app/routes/vendor-agreement';
import { I18nProvider } from './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<Navigate to="/ar" replace />} />

        <Route
          path="/:lang"
          element={
            <I18nProvider>
              <Layout />
            </I18nProvider>
          }
        >
          <Route index element={<Home />} />
          <Route path="service-provider" element={<ServiceProvider />} />
        </Route>

        <Route path="/terms-and-privacy" element={<TermsAndPrivacy />} />
        <Route path="/vendor-agreement" element={<VendorAgreement />} />
        <Route path="/customer-agreement" element={<CustomerAgreement />} />

        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
